import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, BACKGROUND_ROW_HORIZONTAL, BORDER_SIZE_ROW_HORIZONTAL } from '../../../globals';


export const StyledRowHorizontal = styled.div`
  margin: 15px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;
  border-bottom: ${BORDER_SIZE_ROW_HORIZONTAL}px solid ${BACKGROUND_ROW_HORIZONTAL};
}
`;



// WEBPACK FOOTER //
// ./src/common/RowHorizontal/styles/StyledRowHorizontal.js